import { Delete, Edit, VisibilityOutlined } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Base64Image } from '../../../../utils/settings';
import { getPancardImageAction } from '../APIs/action';

const DetailCard = ({
  details,
  handleDelete = null,
  isNominee = false,
  beneficiary_id = null,
  handleEdit = null,
  selectedCompanyEntity
}) => {
  const [openImage, setOpenImage] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState('');
  const [loader, setLoader] = React.useState(false);
  const [panImageError, setPanImageError] = React.useState('');
  
  const handleViewImage = (id, selectedCompanyEntity, panImageError) => {
    getPancardImage(id, selectedCompanyEntity);
    !panImageError && setOpenImage(true);
  };
  const handleClose = () => {
    setOpenImage(false);
    setSelectedImage('');
  };
  const DetailFieldWithImage = ({ openImage, selectedImage, handleClose }) => (
    <Dialog
      open={openImage}
      onClose={handleClose}
      maxWidth='sm'
    >
      <DialogContent sx={{ textAlign: 'center' }}>
        {loader ? (
          <CircularProgress sx={{ color: '#FFA525', fontSize: '30px' }} />
        ) : (
          selectedImage && (
            <Base64Image
              base64String={selectedImage}
              style={{ width: '300px', marginBottom: '10px' }}
            />
          )
        )}
      </DialogContent>
    </Dialog>
  );
  const DetailField = ({ label, value, handleViewImage, panImageError }) => (
    <Box
      display='flex'
      justifyContent='space-between'
      sx={{ py: 1 }}
    >
      <Typography
        fontWeight={700}
        sx={{ color: '#666666', fontSize: '13px', lineHeight: '20px' }}
      >
        {label}
      </Typography>
      <Box>
        <Box
          display='flex'
          justifyContent='space-between'
          mb={1}
        >
          <Typography sx={{ color: '#333333', fontSize: '13px', pr: 1 }}>
            {value}
          </Typography>
          {label === 'PAN' && (
            <Box sx={{}}>
              <VisibilityOutlined
                onClick={() => handleViewImage(details?.id, selectedCompanyEntity, panImageError)}
                fontSize='small'
                sx={{ color: '#FFA525', cursor: 'pointer' }}
              />
            </Box>
          )}
        </Box>
        {label === 'PAN' && panImageError && (
          <Typography sx={{ color: '#CC0000', fontSize: '14px' }}>
            {panImageError}
          </Typography>
        )}
      </Box>
    </Box>
  );
  const getPancardImage = async (beneficiary_id, selectedCompanyEntity) => {
    setLoader(true);
    const { error, data } = await getPancardImageAction(beneficiary_id, selectedCompanyEntity);
    setLoader(false);
    if (!error) {
      setSelectedImage(data.pancard_image);
    } else {
      setPanImageError('No Image Found');
    }
  };
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 1,
        }}
      >
        <Box>
          <Typography
            variant='body1'
            sx={{ fontWeight: 700, fontSize: '16px', lineHeight: '24px' }}
          >
            {details?.header_title}
          </Typography>
        </Box>
        <Box>
          {details?.isEditable && ( 
            <Tooltip title='Edit'>
              <IconButton
                sx={{ color: '#FFA525', mr: 1 }}
                onClick={() => handleEdit(details, isNominee, beneficiary_id)}
              >
                <Edit fontSize='small' />
              </IconButton>
            </Tooltip>
          )}
          {handleDelete && details?.isDeletable && (
            <Tooltip title='Delete'>
              <IconButton
                size='small'
                sx={{ color: '#FFA525' }}
                onClick={() => {
                  if (isNominee && beneficiary_id && details.id) {
                    handleDelete(beneficiary_id, true, details?.id);
                  } else if (details.id) {
                    handleDelete(details.id);
                  }
                }}
              >
                <Delete fontSize='small' />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>
      <Box>
        {details?.details.map((field, idx) => (
          <DetailField
            key={idx}
            label={field.display_name}
            value={field.display_value}
            file_url={field.file_url}
            handleViewImage={handleViewImage}
            panImageError={panImageError}
          />
        ))}
        {!details?.isDeletable && (
          <Typography
            variant='body1'
            sx={{ color: '#666666' }}
          >
            *Above information cannot be edited or deleted.
          </Typography>
        )}
      </Box>
      {!panImageError && (
        <DetailFieldWithImage
          handleClose={handleClose}
          openImage={openImage}
          selectedImage={selectedImage}
        />
      )}
    </Box>
  );
};

export default DetailCard;
